import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type { GetTranscriptMedia } from '@trinity/chat/api/interfaces/transcripts';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = {
  transcriptId: number;
};

export const useFetchTranscriptMedia = (props: Props, options: Options = {}) => {

  const apiClient = useChatApiClient();

  const query = useQuery({
    queryKey: ['transcript.media', props], queryFn: ({ queryKey }) => {
      const params = queryKey[1];
      return apiClient.transcripts.getTranscriptMedia(params);
    }, ...options,
  });

  return query;
};

type Data = GetTranscriptMedia.Response;
type QK = readonly [string, Props];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QK>, 'queryKey' | 'queryFn'>;